import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { NotificationProvider } from './contexts/NotificationContext'
import { AuthProvider } from './contexts/AuthContext'
import { CartProvider } from './contexts/CartContext'
import ToastContainer from './components/feedback/Toast'

function App() {
  return (
    <BrowserRouter 
      basename={__BASE_PATH__}
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <NotificationProvider>
        <AuthProvider>
          <CartProvider>
            <AppRoutes />
            <ToastContainer />
          </CartProvider>
        </AuthProvider>
      </NotificationProvider>
    </BrowserRouter>
  )
}

export default App